module.exports = __webpack_public_path__ + "media/src/images/icons/notice/light-blue-6dbc3aff5c792088f8fc069e0f9883c6.svg";